import { useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import { fetchAnnouncementsSummary } from '../api/announcementsApi';

/** Unseen-count for the settings badge and the home popup. One request per page load. */
export function useUnseenAnnouncements() {
  const { user } = useAuth();
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!user) return undefined;
    let cancelled = false;
    fetchAnnouncementsSummary().then((s) => {
      if (!cancelled) setCount(s.unseenCount || 0);
    });
    return () => { cancelled = true; };
  }, [user]);
  return count;
}
